import view from './View.js';

class addRecipeView extends view {
  _parentElement = document.querySelector('.upload');
  _message = 'Recipe successfully uploaded :)';

  _overlay = document.querySelector('.overlay');
  _window = document.querySelector('.add-recipe-window');

  _btnAddRecipe = document.querySelector('.nav__btn--add-recipe');
  _btnCloseModal = document.querySelector('.btn--close-modal');
  _btnUpload = document.querySelector('.upload__btn');

  constructor() {
    super();
    this.addHandlerShowModal();
    this.addHandlerHideModal();
  }

  toggleWindow() {
    this._overlay.classList.toggle('hidden');
    this._window.classList.toggle('hidden');
  }
  hideWindow() {
    this._overlay.classList.add('hidden');
    this._window.classList.add('hidden');
  }

  addHandlerShowModal() {
    this._btnAddRecipe.addEventListener('click', this.toggleWindow.bind(this));
  }
  addHandlerHideModal() {
    this._overlay.addEventListener('click', this.hideWindow.bind(this));
    this._btnCloseModal.addEventListener('click', this.hideWindow.bind(this));
  }
  addHandlerUpload(handler) {
    this._parentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      const data = [...new FormData(this)];
      handler(data);
    });
  }
}

export default new addRecipeView();
